[].slice.call(document.querySelectorAll('.locations-picker-list li')).forEach(function(location) {
	location.addEventListener('click', function() {
		var locationContentSection = this.closest('section.location_content'),
			locationsButton = locationContentSection.querySelector('.locations-button'),
			selected = this.parentNode.querySelector('.selected');

		if(this != selected) {
			selected.classList.remove('selected');
			this.classList.add('selected');
			locationsButton.innerHTML = this.innerHTML;
			closeCustomDropdown(locationsButton);

			[].slice.call(document.querySelectorAll('section.location-based-content')).forEach(function(section) {
				section.remove();
			});

			var slug = this.getAttribute('value');

			if(slug) {
				var data = {
					'slug' : slug,
					'bg-color' : locationsButton.getAttribute('bg-color'),
					'content-type' : locationsButton.getAttribute('content-type')
				};

				axios.post('/get-location-content', data).then(function(r) {
					locationContentSection.insertAdjacentHTML('afterend', r.data.content);
					scrollToElement(locationContentSection.nextElementSibling);
				});
			}
		}
	});
});

var Observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if(document.querySelector('section.location-based-content')) {
        	for(var i = 0; i < mutation.addedNodes.length; i++) {
	        	[].slice.call(mutation.addedNodes[i].querySelectorAll('button')).forEach(function(accordionButton, index) {
	            	accordionButton.addEventListener('click', function() {
	            		accordionClick(this, index);
	            	});
	        	});
	        }
        }
    });
});

Observer.observe(main, {
    childList: true,
    subtree: true
});